var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('trip-detail',{attrs:{"trip-id":_vm.tripId,"edit-mode":_vm.editMode,"pilot-id":_vm.pilotId,"tag-id":_vm.tagId},on:{"switchEditMode":function($event){return _vm.switchEditMode($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }